module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// ./bower_components/bootstrap/dist/fonts/glyphicons-halflings-regular.eot
// module id = 229
// module chunks = 2